import { Box } from "@mui/material";
import MenuIcon from "../../images/menu-icon.svg";
import MenuItem from "./MenuItem";
import { FC } from "react";
import { Swiper as SwiperType } from "swiper";

const pagesData = [
  {
    id: 1,
    title: "پایداری چیست؟",
    index: 1,
  },
  {
    id: 2,
    title: "سارودی",
    index: 3,
  },
  {
    id: 3,
    title: "تأثیر محصولات سارودی بر پایداری",
    index: 4,
  },
  {
    id: 4,
    title: "بیانیه ریبرندینگ",
    index: 7,
  },
  {
    id: 5,
    title: "جایگاه جدید ایمن آب",
    index: 8,
  },
];

const getCurrectNavigationFromCurrentIndex = (currentIndex: number) => {
  switch (currentIndex) {
    case 0:
      return 0;

    case 1:
    case 2:
      return 1;

    case 3:
      return 2;

    case 4:
    case 5:
    case 6:
      return 3;

    case 7:
      return 4;
    case 8:
      return 5;
  }
};

interface Props {
  activeIndex: number;
  swiper: SwiperType | null;
}

const NavBar: FC<Props> = ({ activeIndex, swiper }) => {
  const handleNavbarClick = (id: number) => {
    swiper && swiper.slideTo(id);
  };

  return (
    <Box
      sx={{
        display: "flex",
        opacity: activeIndex === 0 || activeIndex === 9 ? "0" : "1",
        transition: "opacity .5s .2s",
        flexDirection: "column",
        gap: "1rem",
        paddingTop: { xs: "3rem", lg: "5rem", xl: "8rem" },
        paddingRight: { xs: "2rem", lg: "5rem", xl: "10rem" },
        overflow: "hidden",
      }}
    >
      <img
        src={MenuIcon}
        style={{ width: "36px", height: "36px", cursor: "pointer" }}
        alt="Menu icon."
      />
      <Box
        sx={{
          marginRight: "1rem",
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Box
          sx={{
            background: "#9BBFC7",
            minHeight: "10rem",
            width: "2px",
            flexGrow: "2",
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: ".8rem",
            marginRight: "-.2rem",
          }}
        >
          {pagesData.map(({ id, title, index }) => (
            <MenuItem
              onClick={() => handleNavbarClick(index)}
              key={id}
              active={getCurrectNavigationFromCurrentIndex(activeIndex) === id}
              title={title}
            />
          ))}
        </Box>
        <Box
          sx={{
            background: "#9BBFC7",
            minHeight: { lg: "40dvh", xl: "51dvh" },
            width: "2px",
          }}
        />
      </Box>
    </Box>
  );
};

export default NavBar;
